module.exports = __webpack_public_path__ + "img/pinJuntos.0d99348e.jpg";